(function ($) {
    const behavior = 'polyu_theme.views-pg-programmes';
    var pg_filter_count = 0;
    Drupal.behaviors[behavior] = {
        attach: (context, settings) => {
            once(behavior, '.form--views-exposed-form-pg-programmes-find-your-programmes').forEach(block => {
                pg_find_program_show_count_filter();
                pg_wrap_second_filter();
            })
            context.querySelectorAll('.container--view--pg-programmes--find-your-programmes .views-infinite-scroll-content-wrapper').forEach(pattern => {
                pg_toggle_collapsible(pattern);
            })
            context.querySelectorAll('.container--view--pg-programmes--programme-listing .views-infinite-scroll-content-wrapper').forEach(pattern => {
                pg_toggle_collapsible(pattern);
            })
        },

    };
    $(function () {
        pg_program_admission_year_filter_trim_entry();
        pg_handler_find_program_custom_search_button();
        pg_find_program_show_filter_button();
        pg_program_listing_remove_same_grouping();
        pg_find_your_program_remove_same_grouping();
    });

    function pg_program_admission_year_filter_trim_entry() {
        $('fieldset[data-drupal-selector="edit-pg-programmes-semester-term-value"] label').text(function () {
            return $(this).text().replaceAll('Entry', '').trim();
        });
    }

    function pg_program_listing_remove_same_grouping() {
        var updating = false;
        $('.container--view--pg-programmes--programme-listing .views-infinite-scroll-content-wrapper').on('DOMSubtreeModified', function () {
            if(updating) {
                return;
            }
            var showed_faculty = [];

            $(this).find('.sorting-letter .faculty').each(function () {
                var faculty_id = $(this).data("id");
                if ($.inArray(faculty_id, showed_faculty) == '-1') {
                    showed_faculty.push(faculty_id);
                } else {
                    updating = true;
                    $(this).parent().parent().prev().children('.programmes-items').append($(this).parent().next('.programmes-items').html());
                    $(this).parent().parent().remove();
                }
            })
            updating = false;
        });
    }

    function pg_find_your_program_remove_same_grouping() {
        var updating = false;
        $('.container--view--pg-programmes--find-your-programmes .views-infinite-scroll-content-wrapper').on('DOMSubtreeModified', function () {
            if(updating) {
                return;
            }
            var showed_faculty = [];

            $(this).find('.sorting-letter .faculty').each(function () {
                var faculty_id = $(this).data("id");
                if ($.inArray(faculty_id, showed_faculty) == '-1') {
                    showed_faculty.push(faculty_id);
                } else {
                    updating = true;
                    $(this).parent().parent().prev().children('.programmes-items').append($(this).parent().next('.programmes-items').html());
                    $(this).parent().parent().remove();
                }
            })
            updating = false;
        });
    }

    function pg_handler_find_program_custom_search_button() {
        $(document).on('click', '.search_button', function (e) {
            $('.form-submit[value=Search]').click();
        });


        $('.rpg_search_button').on('click', function (e) {
            $('#rpg_search').submit();
        });

        $('.tpg_search_button').on('click', function (e) {
            $('#tpg_search').submit();
        });
    }

    function pg_find_program_show_filter_button() {
        const form = $('.form--views-exposed-form-pg-programmes-find-your-programmes');
        const show_filter_button = form.find('.show_filter');
        const second_filter = form.find('.second_filter');
        const hide_filter = "Hide Filters<i class=\"fa-light fa-angle-up\"></i>"
        const show_filter = "Show Filters <span class='filter-count'>" + pg_filter_count + "</span><i class=\"fa-light fa-angle-down\"></i>"

        if (second_filter != "undefined") {
            if (second_filter.css("display") !== 'none') {
                show_filter_button.html(hide_filter);
            } else {
                show_filter_button.html(show_filter);
            }
        }
    }

    function pg_find_program_show_count_filter() {
        const form = $('.form--views-exposed-form-pg-programmes-find-your-programmes');
        const fieldset = form.find('.fieldset');
        pg_filter_count = 0;
        form.find('.fieldset input[type=checkbox]').each(function () {
            if ($(this).is(':checked')) {
                pg_filter_count++;
            }
        });
    }

    function pg_wrap_second_filter() {
        const form = $('.form--views-exposed-form-pg-programmes-find-your-programmes');
        const separatedSelectors = [
            '.form--views-exposed-form-pg-programmes-find-your-programmes .form-item-pg-programmes-faculty-school-target-id-verf',
            '.form--views-exposed-form-pg-programmes-find-your-programmes .form-item-pg-programmes-label-target-id-verf',
            '.form--views-exposed-form-pg-programmes-find-your-programmes .form-item-pg-programmes-study-mode-value',
            '.form--views-exposed-form-pg-programmes-find-your-programmes .form-composite',
            '.form--views-exposed-form-pg-programmes-find-your-programmes .form-actions'
        ];
        const separatedSelectorsString = separatedSelectors.join(', ');
        if (form.find('.first_filter').length == 0) {
            $(separatedSelectorsString).wrapAll("<div class='second_filter' style='display: none;'></div>");
            form.find('.form-item-programme-keyword').append('<div class="search_button"><i class="fa-light fa-magnifying-glass"></i></div>')
            form.find('.form-item-programme-keyword').wrapAll("<div class='first_filter'></div>")
            form.find('.first_filter').append('<div class="show_filter pg">Show Filters <span class="filter-count">' + pg_filter_count + '</span><i class="fa-light fa-angle-down"></i></div>')
        }

        form.find('.show_filter').on('click', function (e) {
            form.find('.second_filter').slideToggle(null, null, function () {
                setTimeout(pg_find_program_show_filter_button(), 100);
            });
        });
    }

    function pg_toggle_collapsible(pattern) {
        const items = pattern.querySelectorAll('.programmes-row');
        if (items.length === 0) return;

        const toggle = (item, state) => {
            item.classList.toggle('active', state);
        }

        items.forEach((item, i) => {
            const arrow = item.querySelector('.sorting-letter');
            if (arrow === null) return;

            arrow.onclick = function () {
                let active = [...pattern.querySelectorAll('.programmes-row.active')];
                var otherActiveElements = active.filter(function (element) {
                    return element !== item;
                });
                for (let j = 0; j < otherActiveElements.length; j++) {
                    var active_content = active[j].querySelector('.sorting-letter').nextElementSibling;
                    active_content.style.maxHeight = null;
                    active[j].classList.remove('active');
                }
                item.classList.toggle('active');

                var isOpen_content = arrow.nextElementSibling;
                if (isOpen_content.style.maxHeight) {
                    isOpen_content.style.maxHeight = null;
                } else {
                    isOpen_content.style.maxHeight = isOpen_content.scrollHeight + "px";
                }
            }
        });
    }
})(jQuery);
